module.exports = __webpack_public_path__ + "img/antes_despues_149.ac576929.png";